import { getJson, postJson } from './BaseApi'

export const getEvacuationPlanByConfiguration = configurationId =>
  getJson({ url: '/api/evacuation/plan/' + configurationId })

export const createEvacuationPlans = evacuationPlans =>
  postJson({ url: '/api/evacuation/plans', data: evacuationPlans })
